import classNames from '../../../../../../_virtual/index.mjs';
import React__default, { forwardRef } from 'react';
import modules_1d7499fc from './Typography.module.css.mjs';

const Typography = /*#__PURE__*/ forwardRef(({ variant = 'body', as = 'div', weight, font, color, align, className, ...props }, ref)=>{
    // Without this cast, TS thinks Element might not even be an HTML element and so does not have className
    const Element = as;
    return /*#__PURE__*/ React__default.createElement(Element, {
        ...props,
        ref: ref,
        className: classNames(className, modules_1d7499fc.typography, modules_1d7499fc[variant], font && modules_1d7499fc[font + 'Font'], weight && modules_1d7499fc[weight], color && modules_1d7499fc[color], align && modules_1d7499fc[align])
    });
});

export { Typography as default };
//# sourceMappingURL=Typography.mjs.map
